const createAddressProviderPlugin = ({ addressesCacheAtom, }) => {
    const onLock = () => addressesCacheAtom.set(undefined);
    return { onLock };
};
const addressProviderPluginDefinition = {
    id: 'addressProviderPlugin',
    type: 'plugin',
    factory: createAddressProviderPlugin,
    dependencies: ['addressesCacheAtom'],
};
export default addressProviderPluginDefinition;
